import { InputText as UIInputText } from "@webmotors/eleanor-ui";
import type { InputProps as UIInputTextProps } from "@webmotors/eleanor-ui/webmotors/input-text";
import type { FocusEventHandler } from "react";

export type InputTextProps = UIInputTextProps & {
  onBlur?: FocusEventHandler<HTMLInputElement>;
};

export function InputText(props: Readonly<InputTextProps>) {
  return <UIInputText {...props} data-testid="input-text" />;
}
